module.exports = __webpack_public_path__ + "static/media/stars.e3555761.jpg";